"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SanctionScreeningPerformer = void 0;
const Field_type_1 = require("../../../types/Field.type");
const SanctionsScreeningPerformer_1 = require("../../enm/SanctionsScreeningPerformer");
exports.SanctionScreeningPerformer = {
    priority: 1,
    label: 'fields.enm.sanctions_screening_performer.label',
    fallbackLabel: 'Are sanction screenings conducted internally, or is this task outsourced to an external party (e.g. consulting company)?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.Enum,
    options: SanctionsScreeningPerformer_1.SanctionsScreeningPerformerRef.options,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
